import React from "react";
import SectionTitle from "./section-title";
import "./book-page.m.css";


export default function UpcomingBookBlocks({
  title = "Upcoming Books:",
  src = "https://images.assettype.com/newslaundry/2026-06-19/",
  upcomingBooks = [
    "y11ymohg/good-things-.png",
    "cc73i5ia/take-.png",
    "24gxxqx1/time-.png",
  ],
}) {
  return (
    <section styleName="upcoming-books">
      <SectionTitle title={title} width="14%" />

      <div styleName="upcoming-books-grid">
        {upcomingBooks.map((img, index) => (
          <div key={index} styleName="upcoming-book-card">
            <img
              loading="lazy"
              src={`${src}${img}`}
              alt=""
              styleName="upcoming-book-image"
            />
          </div>
        ))}
      </div>
    </section>
  );
}
